import {TaskResponse} from './task-response';

export class TaxStatusResponse extends TaskResponse {

  comments!: string;

}

